// extracted by mini-css-extract-plugin
export default {"modalButtonWrapper":"styles_modalButtonWrapper__hJDYG","selected":"styles_selected__Bqs0y"};